var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Select2Editable from './select2_dropdown';
var i18n = {
    REPLACE: ACP_Editing.i18n.replace_with,
    ADD: ACP_Editing.i18n.add,
    REMOVE: ACP_Editing.i18n.remove
};
var TEMPLATE = "\n\t<div class=\"input__group -type\">\n\t<select class=\"type\" name=\"save_strategy\">\n\t\t<option value=\"replace\">" + i18n.REPLACE + "..</option>\n\t\t<option value=\"add\">" + i18n.ADD + "..</option>\n\t\t<option value=\"remove\">" + i18n.REMOVE + "..</option>\n\t</select>\n\t</div>\n";
var TextEditable = /** @class */ (function (_super) {
    __extends(TextEditable, _super);
    function TextEditable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextEditable.prototype.render = function () {
        _super.prototype.render.call(this);
        this.getElement().querySelector('.aceditable__form__inputs').insertAdjacentHTML("afterbegin", TEMPLATE);
        if (this._args.mode === 'inline') {
            this.getTypeElement().style.display = 'none';
            this.getTypeElement().value = 'replace';
        }
        else {
            this.getTypeElement().style.display = 'block';
        }
    };
    TextEditable.prototype.getTypeElement = function () {
        return this.getElement().querySelector('[name=save_strategy]');
    };
    TextEditable.prototype.getValue = function () {
        return {
            terms: _super.prototype.getValue.call(this),
            save_strategy: this.getElement().querySelector('[name=save_strategy]').value
        };
    };
    TextEditable.prototype._setDefaults = function () {
        this._defaults.type = 'taxonomy';
    };
    return TextEditable;
}(Select2Editable));
export default TextEditable;
